// 表单验证
import type { FormInstance, FormItemProp } from "element-plus";
// 身份证
const validateIdnumber = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (!value) {
    return callback(new Error("证件号码不能为空"));
  } else if (!reg.test(value)) {
    return callback(new Error("证件号码不正确"));
  } else {
    callback();
  }
};

// 手机号
const validatePhone = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  // console.log("validatePhone", rule);
  const reg =
    /^(1[3-9][0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
  if (!value) {
    return callback(new Error("手機號碼不能爲空"));
  } else if (!reg.test(value)) {
    return callback(new Error("手機號碼不正確"));
  } else {
    callback();
  }
};
// 邮箱
const validateEmail = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^[a-zA-Z0-9][a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  if (!value) {
    return callback(new Error("邮箱不能为空"));
  } else if (!reg.test(value)) {
    return callback(new Error("邮箱格式不正确"));
  } else {
    callback();
  }
};
// 香港手机号
const validateHkPhone = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  console.log("validateHkPhone", rule);
  const reg = /^(4|5|6|8|9)\d{7}$/;
  console.log("!reg.test(value)", reg.test(value));
  if (!value) {
    return callback(new Error("手機號碼不能爲空"));
  } else if (!reg.test(value)) {
    return callback(new Error("手機號碼不正確"));
  } else {
    callback();
  }
};

// 类似金钱,首位不为0,最多2位小数
const validateMoney = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg =
    /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
  if (!value) {
    return callback(new Error("请填写数字"));
  } else if (!reg.test(value)) {
    return callback(new Error("请填写数字,最多2位小数"));
  } else {
    callback();
  }
};

const vMoney = function (errorMessage: string | undefined) {
  return function (
    rule: any,
    value: any,
    callback: (arg0?: Error | undefined) => void
  ) {
    const reg =
      /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    if (!value || value <= 0) {
      return callback(new Error(errorMessage));
    } else if (!reg.test(value)) {
      return callback(new Error("请正确填写数字,最多2位小数"));
    } else {
      callback();
    }
  };
};

// 股东占比,首位不为0,最多3位小数
const validateSharesNum = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^[0-9]{1,3}(\.[0-9]{1,3})?$/;
  if (!value) {
    return callback(new Error("请填写股东信息"));
  } else if (parseFloat(value) > 100) {
    return callback(new Error("占比不能超过100%"));
  } else if (parseFloat(value) < 25) {
    return callback(new Error("占比不能低于25%"));
  } else if (!reg.test(value)) {
    return callback(new Error("请填写正确格式"));
  } else {
    callback();
  }
};

// 短信验证码
const validSMS = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const num = /^[0-9]*$/;
  if (value == "") {
    callback(new Error("短信验证码不能为空"));
  } else if (!num.test(value)) {
    callback(new Error("短信验证码必须为数字"));
  } else {
    callback();
  }
};

const validNumber = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const num = /^[0-9]*$/;
  console.log("value", value);
  if (!num.test(value)) {
    callback(new Error("请使用数字填写！！"));
  } else {
    callback();
  }
};

// 随机码
const randomCode = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const num = /^[0-9]*$/;
  if (value == "") {
    callback(new Error("随机码不能为空"));
  } else if (!num.test(value)) {
    callback(new Error("随机码必须为数字"));
  } else {
    callback();
  }
};

// 登录密码验证
const validatePass = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/;
  const reg2 = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/;
  if (value === "") {
    callback(new Error("請輸入登錄密碼"));
  } else {
    if (!reg2.test(value) && !reg.test(value)) {
      callback(new Error("請輸入8-20個英文字母、數字的組合"));
    }
    callback();
  }
};

// 支付密码验证
const validatePayPass = (
  rule: any,
  value: string | any[],
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^\d{6}$/;
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    if (value.length > 6) {
      callback(new Error("超过6位字符"));
      return;
    }
    if (!reg.test(value)) {
      callback(new Error("请输入6位数字格式"));
    }
    callback();
  }
};

// 验证卡号
const validCradId = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^\d{14,19}$/;
  if (value == "") {
    callback(new Error("银行卡号不能为空"));
  } else if (value && !reg.test(value.replace(/\s/g, ""))) {
    callback(new Error("银行卡号格式错误"));
  } else {
    callback();
  }
};

// 验证中文
const validCh = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^[^\u4e00-\u9fa5]+$/;
  if (value && !reg.test(value.replace(/\s/g, ""))) {
    callback(new Error("格式错误，请不要输入中文"));
  } else {
    callback();
  }
};

// 银行卡号为空的时候不校验
const nullNovalidCradId = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^\d{14,19}$/;
  if (value && !reg.test(value.replace(/\s/g, ""))) {
    callback(new Error("银行卡号格式错误"));
  } else {
    callback();
  }
};

// 银行卡号为空的时候不校验
const validEn = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^[^\u4e00-\u9fa5]+$/;
  if (value == "") {
    callback(new Error("请输入持卡人姓名"));
  } else if (value && !reg.test(value.replace(/\s/g, ""))) {
    callback(new Error("格式错误，请不要输入中文"));
  } else if (value.length > 255) {
    callback(new Error("不能超过255个字符"));
  } else {
    callback();
  }
};

// 银行卡号为空的时候不校验
const validNameEn = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^[^\u4e00-\u9fa5]+$/;
  if (value === "") {
    callback(new Error("英文名称不能为空"));
  } else if (value && !reg.test(value.replace(/\s/g, ""))) {
    callback(new Error("格式错误，请不要输入中文"));
  } else if (value.length > 255) {
    callback(new Error("不能超过128个字符"));
  } else {
    callback();
  }
};

// swiftCode的切换，只能是8或者11位
const validateSwiftCode = (
  rule: any,
  value: string | any[],
  callback: (arg0?: Error | undefined) => void
) => {
  //   const reg = /^(5|6|8|9)\d{7}$/;
  console.log("数组", value.length);
  if (!value) {
    return callback(new Error("swiftCode不能为空"));
  } else if (value.length !== 8 && value.length !== 11) {
    return callback(new Error("swiftCode的位数为8位或11位数"));
  } else {
    callback();
  }
};

// 只包含数字、字母和空格
const validateForeignArea = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /^[a-zA-Z0-9\s]+$/;
  if (!value) {
    return callback(new Error("地址不能为空"));
  } else if (!reg.test(value)) {
    return callback(new Error("只能包含数字、字母和空格"));
  } else {
    callback();
  }
};

// 营业执照编号，只能是8或者11位
const validateBusinessLicense = (
  rule: any,
  value: string,
  callback: (arg0?: Error | undefined) => void
) => {
  const reg = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)/;
  if (value === "") {
    callback(new Error("营业执照号不能为空"));
  } else if (value && !reg.test(value.replace(/\s/g, ""))) {
    callback(new Error("营业执照号格式错误"));
  } else {
    callback();
  }
};

// 删除验证规则
const delValidRule = (
  formRef: FormInstance,
  name: string | FormItemProp[] | undefined
) => {
  formRef.clearValidate(name);
};

// 验证所有的校验是否可以
// @params:validList需要检验的列表
// @params:stepFormRef需要检验的ref
const validAll = async (validList: any[], stepFormRef: any) => {
  const _validTempList: any[] = [];
  const _fullLen = validList.length; // 需要完成的校验数量
  validList.forEach((item: any) => {
    _validTempList.push(validSingle(item, stepFormRef));
  });
  const _validResult = await Promise.all(_validTempList); //获取全部结果例如：[true, false,true, false]
  const _trueResult = _validResult.filter(d => d); // 过滤非false的数组 : [true,true]
  console.log("检验结果", _trueResult);
  const _allTrue = _trueResult.length === _fullLen ? true : false; // 比对数组的长度是不是所有检验的长度
  console.log("全部结果", _allTrue);
  return _allTrue;
};

// 校验单个props
const validSingle = (validName: string, stepFormRef: any) => {
  return new Promise(resolve => {
    stepFormRef.validateField(validName, (isValid: any) => {
      if (isValid) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
};

// 大陆供应商对公账户
const validateOnlyOfThePublic = (
  rule: any,
  value: string | any[],
  callback: (arg0?: Error | undefined) => void
) => {
  if (value === "") {
    callback(new Error("请输入银行卡号"));
  } else {
    if (value.length > 32) {
      callback(new Error("超过最大限制32位字符"));
      return;
    }
    callback();
  }
};

export {
  validateIdnumber,
  validatePhone,
  validateEmail,
  validateHkPhone,
  validateMoney,
  validSMS,
  validatePass,
  validatePayPass,
  validCradId,
  nullNovalidCradId,
  randomCode,
  validateSharesNum,
  validEn,
  validNameEn,
  validateSwiftCode,
  validateForeignArea,
  validCh,
  validNumber,
  vMoney,
  validateBusinessLicense,
  delValidRule,
  validAll,
  validSingle,
  validateOnlyOfThePublic
};
